// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4418":"10ae5dfc","9664":"8db06d1f"}[chunkId] + ".chunk.css";
};